/* K-AURA — motion layer. Vanilla JS, no dependencies, safe to remove. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  root.classList.add('k-motion');

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var SVGNS = 'http://www.w3.org/2000/svg';

  /* ---------------------------------------------------------------- hero */
  function initHero() {
    var sections = $$('#MainContent .shopify-section');
    var sec = null;
    for (var i = 0; i < sections.length; i++) { if ($('.rich-text__heading', sections[i])) { sec = sections[i]; break; } }
    if (!sec || sec.classList.contains('k-hero')) return;
    sec.classList.add('k-hero');
    var h = $('.rich-text__heading', sec);
    var blocks = $('.rich-text__blocks', sec) || h.parentNode;

    // scent wisp (echo of the K-AURA swirl)
    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('class', 'k-wisp'); svg.setAttribute('viewBox', '-60 -100 120 180'); svg.setAttribute('aria-hidden', 'true');
    svg.innerHTML = '<defs><linearGradient id="kWispGold" x1="0" y1="1" x2="0" y2="0"><stop offset="0" stop-color="#9c7631"/>' +
      '<stop offset=".55" stop-color="#e0ba6c"/><stop offset="1" stop-color="#f6e7b5"/></linearGradient></defs>' +
      '<path class="k-wisp-a" d="M -4 72 C -44 36 34 12 0 -24 C -24 -50 8 -70 14 -88"/>' +
      '<path class="k-wisp-b" d="M 12 62 C -10 36 38 20 18 -6"/>';
    blocks.insertBefore(svg, blocks.firstChild);

    // split the heading into letters
    if (!reduce && !h.getAttribute('data-k-split')) {
      var txt = (h.textContent || '').replace(/\s+/g, ' ').trim();
      h.setAttribute('aria-label', txt); h.setAttribute('data-k-split', '1'); h.textContent = '';
      var n = 0;
      txt.split(' ').forEach(function (word, wi, arr) {
        var w = document.createElement('span'); w.className = 'k-word'; w.setAttribute('aria-hidden', 'true');
        for (var c = 0; c < word.length; c++) {
          var ch = document.createElement('span'); ch.className = 'k-char'; ch.style.setProperty('--i', n++); ch.textContent = word[c]; w.appendChild(ch);
        }
        h.appendChild(w);
        if (wi < arr.length - 1) h.appendChild(document.createTextNode(' '));
      });
    }
    var rule = document.createElement('span'); rule.className = 'k-rule'; rule.setAttribute('aria-hidden', 'true');
    h.insertAdjacentElement('afterend', rule);

    var stage = $('.rich-text', sec) || sec; stage.classList.add('k-stage');
    if (!reduce) dust(stage);
    requestAnimationFrame(function () { requestAnimationFrame(function () { sec.classList.add('is-in'); }); });
  }

  /* golden dust drifting up through the hero */
  function dust(sec) {
    var cv = document.createElement('canvas'); cv.className = 'k-dust'; cv.setAttribute('aria-hidden', 'true');
    sec.insertBefore(cv, sec.firstChild);
    var ctx = cv.getContext('2d'); if (!ctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2), W = 0, H = 0, parts = [], running = false, last = 0;
    var sprite = document.createElement('canvas'); sprite.width = sprite.height = 64;
    var sg = sprite.getContext('2d'), gr = sg.createRadialGradient(32, 32, 0, 32, 32, 32);
    gr.addColorStop(0, 'rgba(255,240,200,1)'); gr.addColorStop(.25, 'rgba(232,196,110,.75)'); gr.addColorStop(1, 'rgba(201,168,76,0)');
    sg.fillStyle = gr; sg.fillRect(0, 0, 64, 64);
    function size() {
      var r = sec.getBoundingClientRect(); W = r.width; H = r.height;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      var count = Math.round(Math.min(90, Math.max(28, W * H / 16000)));
      parts = [];
      for (var i = 0; i < count; i++) parts.push(spawn(true));
    }
    function spawn(anywhere) {
      return { x: Math.random() * W, y: anywhere ? Math.random() * H : H + 10, r: .6 + Math.pow(Math.random(), 2.2) * 2.6,
        v: 6 + Math.random() * 16, ph: Math.random() * 6.28, sw: 6 + Math.random() * 18, a: .25 + Math.random() * .6, tw: 1 + Math.random() * 3 };
    }
    function frame(t) {
      if (!running) return;
      var dt = Math.min(.05, (t - (last || t)) / 1000); last = t;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.y -= p.v * dt; p.ph += dt * .6;
        if (p.y < -12) parts[i] = p = spawn(false);
        var x = p.x + Math.sin(p.ph) * p.sw, fade = Math.min(1, p.y / (H * .25)) * Math.min(1, (H - p.y) / 40 + .2);
        var a = p.a * (.6 + .4 * Math.sin(t / 1000 * p.tw + p.ph)) * Math.max(0, fade);
        var s = p.r * 6; ctx.globalAlpha = a; ctx.drawImage(sprite, x - s / 2, p.y - s / 2, s, s);
      }
      requestAnimationFrame(frame);
    }
    size(); window.addEventListener('resize', size);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { var vis = e[0].isIntersecting; if (vis && !running) { running = true; last = 0; requestAnimationFrame(frame); } if (!vis) running = false; }).observe(sec);
    } else { running = true; requestAnimationFrame(frame); }
  }

  /* -------------------------------------------------------- reveal on view */
  function initReveal() {
    var heads = $$('#MainContent h2, #MainContent .image-with-text__heading').filter(function (el) {
      return !el.closest('.k-hero') && !el.closest('.k-marquee') && !el.classList.contains('k-line') && el.textContent.trim().length;
    });
    heads.forEach(function (el) { el.classList.add('k-line'); if (getComputedStyle(el).textAlign === 'center') el.classList.add('k-line--center'); });
    var frames = $$('#MainContent .image-with-text__media');
    frames.forEach(function (el) { el.classList.add('k-frame'); });
    $$('#MainContent .card-wrapper .card__inner').forEach(function (inner) {
      if (!$('.k-light', inner)) { var l = document.createElement('span'); l.className = 'k-light'; l.setAttribute('aria-hidden', 'true'); inner.appendChild(l); }
    });
    var targets = heads.concat(frames);
    if (reduce || !('IntersectionObserver' in window)) { targets.forEach(function (el) { el.classList.add('k-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('k-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: .15 });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------- scroll progress + parallax (one rAF) */
  function initScroll() {
    if (reduce) return;
    var bar = document.createElement('div'); bar.className = 'k-progress'; bar.setAttribute('aria-hidden', 'true'); document.body.appendChild(bar);
    var imgs = $$('#MainContent .image-with-text__media img');
    var ticking = false;
    function update() {
      ticking = false;
      var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      bar.style.transform = 'scaleX(' + Math.min(1, window.scrollY / max).toFixed(4) + ')';
      var vh = window.innerHeight;
      imgs.forEach(function (img) {
        var r = img.parentNode.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = ((r.top + r.height / 2) - vh / 2) / vh;
        img.style.setProperty('--k-par', (k * -38).toFixed(1) + 'px');
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update); update();
  }

  /* -------------------------------------------- candlelight under the cursor */
  function initGlow() {
    if (reduce || !finePointer) return;
    var g = document.createElement('div'); g.className = 'k-glow'; g.setAttribute('aria-hidden', 'true'); document.body.appendChild(g);
    var tx = innerWidth / 2, ty = innerHeight / 3, x = tx, y = ty, on = false;
    window.addEventListener('pointermove', function (e) { tx = e.clientX; ty = e.clientY; if (!on) { on = true; g.classList.add('is-on'); } }, { passive: true });
    document.addEventListener('pointerleave', function () { on = false; g.classList.remove('is-on'); });
    (function loop() { x += (tx - x) * .09; y += (ty - y) * .09; g.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)'; requestAnimationFrame(loop); })();
  }

  /* ------------------------------------------------- "Our Story" menu anchor */
  function initAnchors() {
    if (document.getElementById('our-story')) return;
    var media = $('#MainContent .image-with-text__media');
    var sec = media && media.closest('.shopify-section');
    if (!sec) return;
    var a = document.createElement('span'); a.id = 'our-story'; a.className = 'k-anchor'; sec.insertBefore(a, sec.firstChild);
    if (location.hash === '#our-story') setTimeout(function () { a.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); }, 400);
  }

  function init() { try { initHero(); } catch (e) {} try { initReveal(); } catch (e) {} try { initScroll(); } catch (e) {} try { initGlow(); } catch (e) {} try { initAnchors(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { try { initHero(); initReveal(); } catch (e) {} });
})();
